import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { CardBody, CardHeader, CardTitle, Form } from "reactstrap";
import MDButton from "components/MDButton";
import { GetSlideByIdCall } from "../../redux/api/title.api";
import { DeleteFile } from "../../redux/api/upload.api";
import { store } from "../../redux/store";
import { basicURL } from "../../apiManager/APIConfig";
import "./map.css";
import "@google/model-viewer";

function ShowThreeD() {
  const fileInputRef = useRef();
  const { id, lang } = useParams();

  const [slideData, setSlideData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [modelUrl, setModelUrl] = useState("");
  const [activeDeleteButton, setActiveDeleteButton] = useState(false);

  // Fetch slide and get model URL
  useEffect(() => {
    const fetchSlide = async () => {
      const res = await GetSlideByIdCall({ id, lang });
      setSlideData(res);
      const url = res?.Files?.[0]?.url;
      setModelUrl(
        url ||
          "https://core.microlab.help/storage/slides/1756131957960-corti.glb/corti.glb"
      );
      setActiveDeleteButton(Boolean(url));
    };
    fetchSlide();
  }, [id, lang]);

  // Handle upload or delete
  
  const uploaderTitle =
    uploadProgress !== 100
      ? `Upload Progress: ${uploadProgress}%`
      : "Extracting the zip file, this may take a while...";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="content">
        <CardHeader>
          {showLoader && (
            <CardBody>
              <Form>
                <div>
                  <div>{uploaderTitle}</div>
                  <div
                    style={{
                      marginBottom: 20,
                      height: 10,
                      backgroundColor: "#ddd",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: `${uploadProgress}%`,
                        backgroundColor: "green",
                      }}
                    ></div>
                  </div>
                </div>
              </Form>
            </CardBody>
          )}
        </CardHeader>

        <div className="container">
          {!modelUrl ? (
            <div className="loadingOrErrorView">
              <div>No 3D model found</div>
            </div>
          ) : (
            <div style={{ width: "100%", height: "80vh" }}>
              <model-viewer
                src={modelUrl}
                alt="3D Model"
                camera-controls
                auto-rotate
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ShowThreeD;
